module.exports = __webpack_public_path__ + "static/media/epa-background2.4ac24580.svg";